var map = {
	"./arrow-down.svg": 77,
	"./arrow-up.svg": 67,
	"./atmosphere.svg": 261,
	"./bioenergy.svg": 262,
	"./bioenergy_css.svg": 263,
	"./carbon_capture.svg": 264,
	"./close-button-white.svg": 103,
	"./dac.svg": 265,
	"./electricity.svg": 266,
	"./energy_efficiency.svg": 267,
	"./exit-fullscreen.svg": 104,
	"./fullscreen.svg": 105,
	"./geo_storage.svg": 268,
	"./hydrocarbons.svg": 269,
	"./hydrocarbons_css.svg": 270,
	"./industrial.svg": 271,
	"./natural_net_sink.svg": 272,
	"./nbr.svg": 273,
	"./net_sinks.svg": 274,
	"./nta.svg": 275,
	"./nuclear.svg": 276,
	"./photosynthesis.svg": 277,
	"./res_and_comm.svg": 278,
	"./res_comm.svg": 279,
	"./reuse.svg": 280,
	"./transports.svg": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;